<div class="modal-body p-0" medptevlog>
  <div [@.disabled]="true" class="h-100 viewer-modal-content">
    <div class="viewer-chat-layout">
      <div class="viewer-pane">
        <div class="remove-all-container">
          <div id="closeAllTab" (click)="removeAllTab()" class="border-0 remove-all-button" medpt-log-action="CloseModel" [attr.medpt-log-message]="'Close ' + tabData.DocumentType + ' Viewer Model all tab'">&times;</div>
        </div>
        <mat-tab-group (selectedIndexChange)="onTabSelectedIndexChange($event)" preserveContent>
          <ng-container *ngFor="let tab of tabs; let index = index">
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="col px-2 viewer-title" [title]="tab.name" kendoTooltip>{{tab.name}}</div>
                <div class="close-tab" (click)="removeTab($event, index)" *ngIf="tab.ViewerContentType != 2" medpt-log-action="CloseModel" [attr.medpt-log-message]="'Close ' +tab.DocumentType + ' Viewer Model'">&times;</div>
              </ng-template>
              <div class="col col-md-12 viewer-frame-container">
                <div class="col col-md-12 viewer-frame-button-container" *ngIf="tab.hasViewerButtons">
                  <input class="primaryBtn m-1" type="button" value="Copy to RegDoc eSafe®" *ngIf="tab.showPlaceInRegDoc" (click)="openPlaceInRegDocModal($event, tab)" medpt-log-action="OpenModel" [attr.medpt-log-message]="'Open Copy to RegDoc eSafe® for ' + tab.DocumentType"/>
                  <input class="primaryBtn m-1" type="button" value="Print" *ngIf="tab.showPrintButton" ngxPrint printSectionId="div_{{tab.tabId}}" [useExistingCss]="true" printTitle="{{tab.name}}" medpt-log-action="Click" [attr.medpt-log-message]="'Print called for ' + tab.DocumentType"/>
                  <input class="primaryBtn m-1" type="button" value="Sign" *ngIf="tab.showSignButton" (click)="openSignatureModal($event, tab)" medpt-log-action="OpenModel" medpt-log-message="Open Sign Model"/>
                  <input class="primaryBtn m-1 ai-insights-btn" type="button" value="AI Insights" *ngIf="enableAIInsights" (click)="openAiInsightsModal(tab)" />
                  <input class="primaryBtn m-1 ask-ai-btn" type="button" value="Ask AI Assistant" *ngIf="enableAIAssistant && !isAiChatOpen" (click)="openAiAssistant()" />
                  <!--<input class="eSign primaryBtn m-1" type="button" value="Demo +" (click)="addNewTab($event, tab)" />-->
                  <div class="clearfix"></div>
                </div>
                <div class="col col-md-12 no-viewer-buttons" *ngIf="!tab.hasViewerButtons">
                  <input class="primaryBtn m-1 ai-insights-btn" type="button" value="AI Insights" *ngIf="enableAIInsights" (click)="openAiInsightsModal(tab)" />
                  <input class="primaryBtn m-1 ask-ai-btn" type="button" value="Ask AI Assistant" *ngIf="enableAIAssistant && !isAiChatOpen" (click)="openAiAssistant()" />
                </div>
                <ng-container *ngIf="tab.hasContentUrl">

                  <iframe *ngIf="tab.ViewerContentType != 1" [src]="tab.contentUrl" (load)="onLoadediframe(this);" frameborder="0" [style.height]="tab.hasViewerButtons ? 'calc(100% - 60px)' : 'calc(100% - 40px)'" style="overflow: hidden; overflow-y: auto;" class="contentbox m-0 p-0"></iframe>

                  <iframe *ngIf="tab.ViewerContentType == 1" name="viewerframe_{{tab.tabId}}" (load)="onLoadediframe(this);" frameborder="0" [style.height]="tab.hasViewerButtons ? 'calc(100% - 60px)' : 'calc(100% - 40px)'" style="overflow: hidden; overflow-y: auto;" class="contentbox m-0 p-0"></iframe>
                  <form *ngIf="tab.ViewerContentType == 1" id="viewerform_{{tab.tabId}}" target="viewerframe_{{tab.tabId}}" [action]="tab.contentUrl" method="post" [hidden]="true">
                    <input type="hidden" name="token" [value]="tab.viewerToken" />
                    <input type="hidden" name="accessToken" [value]="getToken()" />
                    <input type="hidden" name="documentName" [value]="tab.name" />
                    <input type="submit">
                  </form>

                </ng-container>
                <ng-container *ngIf="tab.hashHtmlContent">
                  <div id="div_{{tab.tabId}}" [innerHTML]="tab.htmlContent | keepHtml" class="contentbox m-0" [style.height]="tab.hasViewerButtons ? 'calc(100% - 75px)' : 'calc(100% - 40px)'" style="overflow: hidden; overflow-y: auto;"></div>
                </ng-container>
              </div>
            </mat-tab>
          </ng-container>
        </mat-tab-group>
      </div>

      <medpt-document-viewer-ai-chat
        #viewerAiChat
        [documentContext]="chatDocumentContext"
        (chatAvailabilityChange)="onChatAvailabilityChange($event)"
        (chatOpenStateChange)="onChatOpenStateChange($event)"
        (citationNavigate)="onCitationNavigate($event)">
      </medpt-document-viewer-ai-chat>
    </div>
  </div>

  <medpt-document-viewer-ai-insights
    [isOpen]="isAiInsightsOpen"
    [documentName]="aiInsightsDocName"
    [assetId]="aiInsightsAssetId"
    (closeModal)="closeAiInsightsModal()">
  </medpt-document-viewer-ai-insights>
</div>
